import React from 'react';

interface BoardCenterProps {
  celebratingPiece?: {
    playerId: string;
    pieceId: string;
    color: string;
  } | null;
}

const BoardCenter: React.FC<BoardCenterProps> = ({ celebratingPiece }) => {
  return (
    <div className="destination" data-testid="board-center">
      <div className="center-text" data-testid="center-text">
        🏆
      </div>

      {/* Celebration Animation */}
      {celebratingPiece && (
        <div
          className={`celebrating-piece ${celebratingPiece.color}`}
          data-testid="celebrating-piece"
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            border: '3px solid #fff',
            zIndex: 100,
            animation: 'winCelebration 3s ease-in-out',
            boxShadow: '0 0 20px rgba(255, 215, 0, 0.8)',
          }}
        />
      )}
    </div>
  );
};

export default BoardCenter;
